"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeUHash = exports.computeSingleHash = exports.computeHash = void 0;
const crypto = require("crypto");
const binary_1 = require("./utils/binary");
const format_1 = require("./utils/format");
var DigestFormat;
(function (DigestFormat) {
    DigestFormat["BASE64"] = "base64";
    DigestFormat["HEX"] = "hex";
})(DigestFormat || (DigestFormat = {}));
var HashAlgorithm;
(function (HashAlgorithm) {
    HashAlgorithm["MD5"] = "md5";
    HashAlgorithm["OTHER"] = "other";
})(HashAlgorithm || (HashAlgorithm = {}));
const usedHashAlgorithm = HashAlgorithm.MD5;
async function computeHash(path, content) {
    const hashes = await Promise.all([
        computeSingleHash(content),
        computeUHash(content),
    ]);
    return {
        path: path,
        size: content.length,
        hashes_ffm: hashes,
    };
}
exports.computeHash = computeHash;
async function computeSingleHash(content) {
    const hash = crypto.createHash(usedHashAlgorithm).update(content);
    const base64Digest = hash.digest(DigestFormat.BASE64).replace(/=/g, '');
    return {
        data: base64Digest,
        format: 1,
    };
}
exports.computeSingleHash = computeSingleHash;
async function computeUHash(content) {
    const file = binary_1.isBinary(content) ? content : format_1.removeWhitespaces(content);
    const hash = crypto.createHash(usedHashAlgorithm).update(file);
    const hexDigest = hash.digest(DigestFormat.HEX).slice(0, 24);
    return {
        data: hexDigest,
        format: 3,
    };
}
exports.computeUHash = computeUHash;
//# sourceMappingURL=hash.js.map